import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterOutHidden',
    standalone: true
})
export class FilterOutHiddenPipe implements PipeTransform {
  transform<T extends { id: string }>(items: T[], hiddenSet: Set<string>, visibleNotHidden: boolean = false): T[] {
    return items.filter(({ id }) => visibleNotHidden ? hiddenSet.has(id) : !hiddenSet?.has(id))
  }
}

@Pipe({
    name: 'filterOutHiddenArray',
    standalone: true
})
export class FilterOutHiddenArrayPipe implements PipeTransform {
  transform<T extends { id: string }>(items: T[], hidden: string[]): T[] {
    return items.filter(({ id }) => !(hidden || []).includes(id))
  }
}

@Pipe({
    name: 'filterAllButId',
    standalone: true
})
export class FilterAllButIdPipe implements PipeTransform {
  transform<T extends { id: string }>(items: T[], idToKeep: string): T[] {
    return items.filter(({ id }) => id === idToKeep)
  }
}